<div class="mb-4">
  <div class="flex items-center">
    <mat-icon class="mr-2">{{ iconName }}</mat-icon>
    <h3 class="font-bold text-md mb-0">{{ locationTitle }}</h3>
  </div>

  @if (locationList.length > 0) {
    <div class="ml-6 mt-2">
      <div class="flex flex-wrap gap-2">
        @for (location of locationList; track location) {
          <div
            class="px-3 py-1 rounded-full text-sm bg-blue-50 text-blue-800"
            >
            {{ location }}
          </div>
        }
      </div>
    </div>
  }
</div>
